import { IS_PROD_OR_SANDBOX } from "@/constants/env";

export const AUTHING_APP_ID = IS_PROD_OR_SANDBOX ? "601eb0a2964f91f2f6103721" : "600ee05a00d0cacef0a78c0b";
